export const roleOptions = [
  { label: "Owner", value: "owner" },
  { label: "Supervisor", value: "supervisor" },
  { label: "Admin Gudang", value: "admin-gudang" },
  { label: "Koordinator Lapangan", value: "koordinator-lapangan" },
];

export const accountStatusOptions = [
  { label: "Aktif", value: true },
  { label: "Non-aktif", value: false }
];